import { css } from "styled-components";
export const hideOnTouchDevices = css `
  @media (any-hover: none) {
    display: none;
  }
`;
//# sourceMappingURL=mediaQueries.js.map